import styled from '@emotion/styled';
import { Box, Button, Grid, Table, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import React, { useRef } from 'react'
import Rupee from "../../../../assets/img/profiles/Rupee-Symbol-Black.svg";
import { useReactToPrint } from 'react-to-print';

const ViewPaySlip = ({ userData }) => {
    const STableRow = styled(TableRow)(({ theme }) => ({
        "&:nth-of-type(odd)": {
            backgroundColor: "white",
        },
        // hide last border
        "&:nth-of-type(even)": {
            backgroundColor: "#e6e6fa",
        },
    }));

    const STableCell = styled(TableCell)({
        borderBottomColor: "#000000",
        fontSize: "13px",
        color: "#808080",
    });

    const SNCTableCell = styled(TableCell)({
        borderColor: "#FFFFFF",
        fontSize: "13px",
        color: "#808080",
    });

    const SCTableCell = styled(TableCell)({
        borderBottomColor: "#000000",
        // background: "#a2d8fb",
        // color:"#808080"
    });

    const userPaySlip = userData?.payslips[0] || null

    const earning = [
        {
            "component_name": "Basic",
            "arrears": 0,
            "current": 0,
            "total": userPaySlip?.basic,
            "type": "A"
        },
        {
            "component_name": "HRA",
            "arrears": 0,
            "current": 0,
            "total": userPaySlip?.hra,
            "type": "A"
        },
        {
            "component_name": "Medical Allowance",
            "arrears": 0,
            "current": 0,
            "total": userPaySlip?.medical_allowance,
            "type": "A"
        },
        {
            "component_name": "Conveyance Allowance",
            "arrears": 0,
            "current": 0,
            "total": userPaySlip?.conveyance_allowance,
            "type": "A"
        },
        {
            "component_name": "Special Allowance",
            "arrears": 0,
            "current": 0,
            "total": userPaySlip?.special_allowance,
            "type": "A"
        }
    ]

    const deductions = [
        {
            "component_name": "TDS",
            "arrears": 0,
            "current": 0,
            "total": userPaySlip?.tds,
            "type": "D"
        },
        {
            "component_name": "PT",
            "arrears": 0,
            "current": 0,
            "total": userPaySlip?.pt,
            "type": "D"
        }
    ]


    return (
        <div>
            <>
                {/* *********************New************************* */}
                <Box sx={{ background: "#FFFFFF", borderRadius: "4px", }}>
                    <Box
                        // ref={inputRef}
                        sx={{
                            textAlign: "left",
                            p: 1.5,
                            ml: "auto",
                            mr: "auto",
                        }}
                    >
                        <Grid container sx={{ mb: 1 }}>
                            <Grid item lg={3} md={3} sm={3}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignContent: "center",
                                        textAlign: "center",
                                        p: 1,
                                    }}
                                >
                                    <img
                                        src={sessionStorage.getItem("company_logo")}
                                        alt="Company Logo"
                                        style={{
                                            height: "auto",
                                            marginBottom: "8px",
                                            height: "40px",
                                            width: "auto",
                                            marginRight: "auto",
                                        }}
                                    />
                                </Box>
                            </Grid>

                            <Grid item lg={6} md={6} sm={6}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignContent: "center",
                                        textAlign: "center",
                                        justifyContent: 'center',
                                        p: 1,
                                    }}
                                >
                                    <Typography variant="body2">
                                        <b style={{ fontSize: "16px" }}>
                                            {userData?.company_name}
                                        </b>
                                        <br />
                                        <b>
                                            {userData?.company_address}
                                        </b>
                                        <p>
                                            CIN : {userData?.company_cin || 'Company CIN'}
                                        </p>
                                    </Typography>
                                </Box>
                            </Grid>

                        </Grid>

                        {/* Employee Details Table */}
                        <Box sx={{ width: "100%", p: 1, pt: 0 }}>
                            <TableContainer>
                                <Table
                                    size="small"
                                    aria-label="employee details"
                                    sx={{
                                        width: "100%", borderLeftColor: "red"
                                    }}
                                >
                                    {/* ... (Employee details rows remain exactly the same as in your reference) ... */}
                                    <STableRow sx={{ borderColor: "#FFFFFF" }}>
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>Employee ID</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.employee_id || "-"} */}{userData?.employee_id}
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>Bank Name:</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.bank_name} */} {userData?.bankname}
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>PAN</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.pan} */}  {userData?.pan}
                                            </Typography>
                                        </SNCTableCell>
                                    </STableRow>

                                    <STableRow sx={{ borderColor: "#FFFFFF" }}>
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>Employee Name</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.employee_name} */}
                                                {userData?.employee_name}
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>A/C</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.ac_number} */}
                                                {userData?.ac_number}
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>LOP days</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.absent || "-"} */}
                                                {userPaySlip?.lop_days}
                                            </Typography>
                                        </SNCTableCell>
                                    </STableRow>

                                    <STableRow sx={{ borderColor: "#FFFFFF" }}>
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>Department</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {userData?.department}
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>UAN</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.uan || 'N/A'} */}
                                                {userData?.uan}
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>ESIC</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.esi || 'N/A'} */}
                                                {userData?.esic}
                                            </Typography>
                                        </SNCTableCell>
                                    </STableRow>

                                    <STableRow sx={{ borderColor: "#FFFFFF" }}>
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>Designation</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {userData?.designation}
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>Days in month</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.total_working_days} */}
                                                {userPaySlip?.days_in_month}
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                                    </STableRow>

                                    <STableRow sx={{ borderColor: "#FFFFFF" }}>
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1, }}>
                                            <Typography variant="body2" >
                                                <b>Gender</b>
                                            </Typography>
                                        </SNCTableCell>
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.gender || "-"} */}
                                                {userData?.gender}
                                            </Typography>
                                        </SNCTableCell>
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                <b>Paid days</b>
                                            </Typography>
                                        </SNCTableCell>

                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                                            <Typography variant="body2" >
                                                {/* {payslipData?.user_details?.worked_days || "-"} */}
                                                {userPaySlip?.paid_days}
                                            </Typography>
                                        </SNCTableCell>
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                                        <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                                    </STableRow>
                                </Table>
                            </TableContainer>
                        </Box>
                        <br />

                        {/* Earnings and Deductions Section */}
                        <Box sx={{ height: "100%", p: 1 }}>
                            <TableContainer>
                                {/* Earnings and Deductions in two columns */}
                                <Table
                                    size="small"
                                    aria-label="salary breakdown"
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                    }}
                                >
                                    {/* Earnings Column */}
                                    <Table
                                        size="small"
                                        aria-label="earnings"
                                        sx={{
                                            width: "50%",

                                        }}
                                    >
                                        <STableRow>
                                            <SCTableCell>
                                                <Typography variant="body2">
                                                    <b>Particular</b>
                                                </Typography>
                                            </SCTableCell>
                                            <SCTableCell align="right">
                                                <Typography variant="body2">
                                                    <b>Total (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                                </Typography>
                                            </SCTableCell>
                                        </STableRow>

                                        {earning
                                            ?.sort((a, b) => {
                                                // Sort Basic to the top
                                                if (a.component_name === "Basic") return -1;
                                                if (b.component_name === "Basic") return 1;
                                                return 0; // Keep other items in their original order
                                            })
                                            ?.map((ele, index) => (
                                                <STableRow key={`earning-${index}`}>
                                                    <TableCell>
                                                        <Typography variant="body2">
                                                            {ele?.component_name || '-'}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Typography variant="body2">
                                                            {ele?.total?.toFixed(0) || '0'}
                                                        </Typography>
                                                    </TableCell>
                                                </STableRow>
                                            ))}
                                    </Table>

                                    {/* Deductions Column */}
                                    <Table
                                        size="small"
                                        aria-label="deductions"
                                        sx={{ width: "50%" }}
                                    >
                                        <STableRow height="20px">
                                            <SCTableCell>
                                                <Typography variant="body2">
                                                    <b>Deduction</b>
                                                </Typography>
                                            </SCTableCell>
                                            <SCTableCell align="right">
                                                <Typography variant="body2">
                                                    <b>Total (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                                </Typography>
                                            </SCTableCell>
                                        </STableRow>


                                        {deductions?.map((ele, index) => (
                                            <STableRow key={`deduction-${index}`}>
                                                <TableCell>
                                                    <Typography variant="body2">
                                                        {ele?.component_name || "-"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography variant="body2">
                                                        {ele?.total?.toFixed(0) || "0"}
                                                    </Typography>
                                                </TableCell>
                                            </STableRow>
                                        ))}
                                        {Array.from({
                                            length: Math.max(
                                                0,
                                                (earning?.length || 0) -
                                                (deductions?.length || 0)
                                            ),
                                        }).map((_, index) => (
                                            <STableRow key={`deduction-spacer-${index}`} style={{ borderBottom: '0px' }}>
                                                <TableCell>
                                                    <Typography variant="body2">&nbsp;</Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography variant="body2">&nbsp;</Typography>
                                                </TableCell>
                                            </STableRow>
                                        ))}
                                    </Table>
                                </Table>

                                {/* Gross Salary and Total Deductions */}
                                <Table
                                    size="small"
                                    aria-label="totals"
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                    }}
                                >
                                    <Table size="small" sx={{ width: "50%" }}>
                                        <STableRow>
                                            <TableCell>
                                                <Typography variant="body2">
                                                    <b>Gross Salary (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="body2">
                                                    {/* {Number(payslipData?.user_details?.modified_gross_pay || 0).toFixed(2)} */}
                                                    {Number(userPaySlip?.gross_salary || 0).toFixed(2)}
                                                </Typography>
                                            </TableCell>
                                        </STableRow>
                                    </Table>

                                    <Table size="small" sx={{ width: "50%" }}>
                                        <STableRow>
                                            <TableCell>
                                                <Typography variant="body2">
                                                    <b>Total Deductions (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="body2">
                                                    {/* {payslipData?.user_details?.deduction?.reduce(
                                                (sum, item) => sum + (item?.total || 0),
                                                0
                                              )?.toFixed(0) || "0"} */}
                                                    {userPaySlip?.total_deductions}
                                                </Typography>
                                            </TableCell>
                                        </STableRow>
                                    </Table>
                                </Table>

                                {/* Reimbursement Section */}
                                <Table
                                    size="small"
                                    aria-label="reimbursement"
                                    sx={{ width: "100%" }}
                                >
                                    {/* <STableRow>
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>Reimbursement</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell />
                                        <TableCell />
                                        <TableCell />
                                    </STableRow>

                                    {payslipData?.user_details?.reimbursment?.map((ele, index) => (
                                        <STableRow key={`reimbursement-${index}`}>
                                          <TableCell>
                                            <Typography variant="body2">
                                              {ele?.component_name || "-"}
                                            </Typography>
                                          </TableCell>
                                          <TableCell align="right">
                                            <Typography variant="body2"></Typography>
                                          </TableCell>
                                          <TableCell align="right">
                                            <Typography variant="body2"></Typography>
                                          </TableCell>
                                          <TableCell align="right">
                                            <Typography variant="body2">
                                              {ele?.total?.toFixed(0) || "0"}
                                            </Typography>
                                          </TableCell>
                                        </STableRow>
                                      ))}

                                    <STableRow>
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>Total Reimbursement (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell />
                                        <TableCell />
                                        <TableCell align="right">
                                            <Typography variant="body2">
                                                {payslipData?.user_details?.reimbursment?.reduce(
                                              (sum, item) => sum + (item?.total || 0),
                                              0
                                            )?.toFixed(0) || "0"}
                                                asdfghj
                                            </Typography>
                                        </TableCell>
                                    </STableRow> */}


                                    <STableRow>
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>Net Salary (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell />
                                        <TableCell />
                                        <TableCell align="right">
                                            <Typography variant="body2">
                                                {/* {(payslipData?.user_details?.net_pay?.toFixed(2)) || "0.00"} */}
                                                {userPaySlip?.net_salary}
                                            </Typography>
                                        </TableCell>
                                    </STableRow>
                                </Table>

                                {/* Footer */}
                                <div style={{ textAlign: "center" }}>
                                    <i>
                                        <b>
                                            Total Net Payable ₹
                                            {/* {Math.round(payslipData?.user_details?.net_pay) || "0"} (
                                          {numberToWords(payslipData?.user_details?.net_pay || 0)}) */}
                                            {userPaySlip?.net_salary}
                                        </b>
                                    </i>
                                    <p>
                                        **Total Net Payable = Gross Earnings - Total
                                        Deductions + Total Reimbursements
                                    </p>
                                    <br />
                                    <i>
                                        <p>
                                            **This is a computer generated Payslip, doesn't
                                            require signature of the competent Authority**
                                        </p>
                                    </i>
                                </div>
                                <br />
                            </TableContainer>
                        </Box>
                    </Box>
                </Box>
                {/* *******************New******************** */}
            </>
        </div>
    )
}

export default ViewPaySlip
